/**
 * CurrentUserEmailPicker - custom field do Scaffolder.
 *
 * Auto-preenche o campo com o e-mail do usuario logado (profile OIDC do
 * Keycloak, via identityApi.getProfileInfo()). Readonly — o usuario nao
 * digita. Se o profile nao tiver e-mail, fica vazio (a action entao nao
 * define e-mail no usuario RGW).
 */
import { useEffect } from 'react';
import { FormControl, TextField } from '@material-ui/core';
import { useApi, identityApiRef } from '@backstage/core-plugin-api';
import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import type { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

const CurrentUserEmailPicker = (
  props: FieldExtensionComponentProps<string>,
) => {
  const { onChange, formData, schema } = props;
  const identityApi = useApi(identityApiRef);

  useEffect(() => {
    let cancelled = false;
    identityApi
      .getProfileInfo()
      .then(profile => {
        const email = profile.email ?? '';
        if (!cancelled && email && email !== formData) onChange(email);
      })
      .catch(() => {
        /* sem profile/email: deixa vazio, a action trata */
      });
    return () => {
      cancelled = true;
    };
    // roda uma vez no mount; nao adicionar onChange (Stepper recria a cada render)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormControl margin="normal" fullWidth>
      <TextField
        label={(schema.title as string) ?? 'Criado por'}
        value={formData ?? ''}
        helperText={
          (schema.description as string) ??
          'E-mail do usuario logado (preenchido automaticamente).'
        }
        variant="outlined"
        disabled
        InputProps={{ readOnly: true }}
        InputLabelProps={{ shrink: Boolean(formData) }}
      />
    </FormControl>
  );
};

export const CurrentUserEmailPickerField = createFormField({
  name: 'CurrentUserEmailPicker',
  component: CurrentUserEmailPicker,
});

export const currentUserEmailPickerField = FormFieldBlueprint.make({
  name: 'current-user-email-picker',
  params: {
    field: async () => CurrentUserEmailPickerField,
  },
});
